import { combineReducers } from 'redux-immutable';
import products from '@americanexpress/product-ducks';
import products04 from 'axp-product-ducks';
import composeReducers from '../utils/composeReducers';

export default combineReducers({
  products: composeReducers(products, products04),
});
